import { POLineItemMatch, POLineItemMatchReason } from '@/types/po-match'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useDeleteList, {
  UseDeleteListOptions,
} from '../core-hooks/useDeleteList'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const poLineItemMatchService = buildService<POLineItemMatch>({
  pathCategory: 'po_line_item_matches',
})

const poLineItemMatchReasonService = buildService<POLineItemMatchReason>({
  pathCategory: 'po_line_item_match_reasons',
})

export function useGetPOLineItemMatches({
  filters,
  ...options
}: UseGetListOptions<POLineItemMatch> = {}) {
  const query = useGetList<POLineItemMatch>({
    filters: {
      fields__include: 'match_reasons_ids',
      ...filters,
    },
    queryKey: queryKeys.poLineItemMatches.list({ filters }),
    serviceFn: poLineItemMatchService.getList,
    ...options,
  })

  return {
    poLineItemMatches: query.allData,
    ...query,
  }
}

export function useGetPOLineItemMatchReasons({
  filters,
  ...options
}: UseGetListOptions<POLineItemMatchReason> = {}) {
  const query = useGetList<POLineItemMatchReason>({
    filters,
    queryKey: queryKeys.poLineItemMatchReasons.list({ filters, persist: true }),
    serviceFn: poLineItemMatchReasonService.getList,
    ...options,
  })

  return {
    poLineItemMatchReasons: query.allData,
    ...query,
  }
}

export function useCreatePOLineItemMatch(
  options: UseCreateDetailOptions<POLineItemMatch> = {},
) {
  const mutation = useCreateDetail<POLineItemMatch>({
    serviceFn: poLineItemMatchService.createDetail,
    ...options,
  })

  return {
    createPOLineItemMatch: mutation.mutate,
    createPOLineItemMatchAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeletePOLineItemMatch(options: UseDeleteDetailOptions = {}) {
  const mutation = useDeleteDetail<POLineItemMatch>({
    serviceFn: poLineItemMatchService.deleteDetail,
    ...options,
  })

  return {
    deletePOLineItemMatch: mutation.mutate,
    deletePOLineItemMatchAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeletePOLineItemMatches(options: UseDeleteListOptions = {}) {
  const mutation = useDeleteList<POLineItemMatch>({
    serviceFn: poLineItemMatchService.deleteList,
    ...options,
  })

  return {
    deletePOLineItemMatches: mutation.mutate,
    deletePOLineItemMatchesAsync: mutation.mutateAsync,
    ...mutation,
  }
}
